"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.kw_exported = exports.nanmedian = exports.nanquantile = exports.nanpercentile = exports.average = exports.median = exports.quantile = exports.percentile = void 0;
var _globals_1 = require("../array/_globals");
var kwargs_1 = require("../array/kwargs");
var transform_1 = require("../array/transform");
var _globals_2 = require("./_globals");
/**
 * Compute the q-th percentile of the data along the specified axis.
 */
function percentile(a, q, axis) {
    q = _globals_2.np.divide(q, 100);
    return quantile(a, q, axis);
}
exports.percentile = percentile;
function js_quantile_a_1D_q_01D(a_flat, q_flat, _nan_handling) {
    if (_nan_handling === void 0) { _nan_handling = false; }
    a_flat = __spreadArray([], __read(a_flat), false).sort(transform_1.cmp_nan_at_the_end);
    var n = a_flat.length;
    if (_nan_handling)
        n -= a_flat.reduce(function (cum, x) { return cum + (isNaN(x) ? 1 : 0); }, 0);
    return q_flat.map(function (q) {
        var nq = q * (n - 1);
        var lo = Math.floor(nq);
        if (nq == lo)
            return a_flat[lo];
        var hi = lo + 1;
        if (nq == hi)
            return a_flat[hi];
        return a_flat[lo] * (hi - nq) + a_flat[hi] * (nq - lo);
    });
}
/**
 * Compute the q-th quantile of the data along the specified axis.
 */
function quantile(a, q, axis, _nan_handling) {
    if (_nan_handling === void 0) { _nan_handling = false; }
    q = (0, _globals_1.asarray)(q);
    if (axis != a.shape.length - 1) {
        a = (0, transform_1.swapAxes)(a, axis, -1);
    }
    var outer_shape = q.shape;
    var inner_shape = a.shape.slice(0, -1);
    a = a.reshape(-1, a.shape.at(-1));
    q = q.reshape(-1);
    var _a = __read(a.shape, 2), nrows = _a[0], ncols = _a[1];
    var a_flat = a.flat;
    var q_flat = q.flat;
    var out = new Float64Array(q.size * nrows);
    for (var i = 0; i < nrows; i++) {
        var row = a_flat.slice(i * ncols, (i + 1) * ncols);
        var values = js_quantile_a_1D_q_01D(row, q_flat, _nan_handling);
        var j = i;
        for (var k in values) {
            out[j] = values[k];
            j += nrows;
        }
    }
    return (0, _globals_1.new_NDArray)(out, __spreadArray(__spreadArray([], __read(outer_shape), false), __read(inner_shape), false));
    // a = np.sort(a, { axis: null });
    // const n = _nan_handling ? np.isnan(a).logical_not().sum(0) : a.shape[0];
    // // TODO: throw if out of bounds 
    // const indices_float = op_binary["*"](q, op_binary["-"](n, 1));
    // return n_ary_operation([indices_float], a.shape.slice(1), (iq) => {
    //   const lo = Math.floor(iq);
    //   if (iq == lo) return np.asarray(a.index(iq));
    //   const hi = lo + 1;
    //   if (iq == hi) return np.asarray(a.index(iq));
    //   return average(a.index(`${lo}:${hi + 1}`), 0, asarray([hi - iq, iq - lo]), false);
    // });
}
exports.quantile = quantile;
/**
 * Compute the median along the specified axis.
 */
function median(a, axis, keepdims) {
    var out = quantile(a, 0.5, axis);
    if (keepdims) {
        var shape = a.shape.slice();
        shape[axis] = 1;
        out = out.reshape(shape);
    }
    return out;
}
exports.median = median;
/**
 * Compute the weighted average along the specified axis.
 */
function average(a, axis, weights, keepdims) {
    if (weights === null)
        return _globals_2.np.mean(a, axis);
    // MISSING: assert weights is 1D
    var denominator = _globals_2.np.sum(weights);
    var weights_shape = a.shape.map(function () { return 1; });
    weights_shape[axis] = weights.size;
    weights = weights.reshape(weights_shape);
    var numerator = _globals_2.np.sum(_globals_2.np.multiply(a, weights), axis, keepdims);
    return _globals_2.np.asarray(_globals_2.np.divide(numerator, denominator));
}
exports.average = average;
/**
 * Compute the q-th percentile of the data along the specified axis, while ignoring nan values.
*/
function nanpercentile(a, q, axis) {
    q = _globals_2.np.divide(q, 100);
    return nanquantile(a, q, axis);
}
exports.nanpercentile = nanpercentile;
/**
 * Compute the q-th quantile of the data along the specified axis, while ignoring nan values.
 */
function nanquantile(a, q, axis) {
    return quantile(a, q, axis, true);
}
exports.nanquantile = nanquantile;
/**
 * Compute the median along the specified axis, while ignoring NaNs.
 */
function nanmedian(a, axis, keepdims) {
    var out = nanquantile(a, 0.5, axis);
    if (keepdims) {
        var shape = a.shape.slice();
        shape[axis] = 1;
        out = out.reshape(shape);
    }
    return out;
}
exports.nanmedian = nanmedian;
// /**
//  * Return Pearson product-moment correlation coefficients.
//  */
// export function corrcoef(x: NDArray, y: NDArray, rowvar = true, bias = false, ddof = 0, dtype = Number) {
//   const x_shape = x.shape;
//   const y_shape = y.shape;
//   if (x_shape.length !== 1 || y_shape.length !== 1) throw new Error("Expected 1D arrays");
//   if (x_shape[0] !== y_shape[0]) throw new Error("Expected arrays of the same length");
//   const x_mean = np.mean(x);
//   const y_mean = np.mean(y);
//   const x_std = np.std(x);
//   const y_std = np.std(y);
//   const n = x_shape[0];
//   const cov = np.mean(np.multiply(np.subtract(x, x_mean), np.subtract(y, y_mean)));
//   const corr = np.divide(cov, np.multiply(x_std, y_std));
//   return corr;
// }
// /**
//  * Cross-correlation of two 1-dimensional sequences.
//  */
// export function correlate(a: NDArray, v: NDArray, mode) {
//   throw new Error("Not implemented");
// }
// /**
//  * Estimate a covariance matrix, given data and weights.
//  */
// export function cov(m: NDArray, y: NDArray, rowvar = true, bias = false, ddof = 0, fweights = null, aweights = null) {
//   const m_shape = m.shape;
//   const y_shape = y.shape;
//   if (m_shape.length !== 2 || y_shape.length !== 2) throw new Error("Expected 2D arrays");
//   if (rowvar) {
//     m = np.transpose(m);
//     y = np.transpose(y);
//   }
//   const m_mean = np.mean(m, 1);
//   const y_mean = np.mean(y, 1);
//   const m_centered = np.subtract(m, m_mean.reshape(m_shape[0], 1));
//   const y_centered = np.subtract(y, y_mean.reshape(y_shape[0], 1));
//   const m_weights = fweights || np.ones(m_shape[1]);
//   const y_weights = aweights || np.ones(y_shape[1]);
//   const m_weighted = np.multiply(m_centered, m_weights);
//   const y_weighted = np.multiply(y_centered, y_weights);
//   const cov = np.divide(np.sum(np.multiply(m_weighted, y_weighted), 1), m_shape[1] - ddof);
//   return cov;
// }
// /**
//  * Compute the histogram of a dataset.
//  */
// export function histogram(a: NDArray, bins, range, density, weights) {
//   throw new Error("Not implemented");
// }
// /**
//  * Compute the bi-dimensional histogram of two data samples.
//  */
// export function histogram2d(x: NDArray, y: NDArray, bins, range, density, weights) {
//   throw new Error("Not implemented");
// }
// /**
//  * Compute the multidimensional histogram of some data.
//  */
// export function histogramdd(sample: NDArray, bins, range, density, weights) {
//   throw new Error("Not implemented");
// }
// /**
//  * Count number of occurrences of each value in array of non-negative ints.
//  */
// export function bincount(x: NDArray, weights, minlength) {
//   throw new Error("Not implemented");
// }
// /**
//  * Function to calculate only the edges of the bins used by the histogram function.
//  */
// export function histogram_bin_edges(a: NDArray, bins, range, weights) {
// }
// /**
//  * Return the indices of the bins to which each value in input array belongs.
//  */
// export function digitize(x: NDArray, bins, right) {
//   throw new Error("Not implemented");
// }
/*

Correlating
  - corrcoef(x[, y, rowvar, bias, ddof, dtype]) Return Pearson product-moment correlation coefficients.
  - correlate(a, v[, mode]) Cross-correlation of two 1-dimensional sequences.
  - cov(m[, y, rowvar, bias, ddof, fweights, ...]) Estimate a covariance matrix, given data and weights.

Histograms
 - histogram(a[, bins, range, density, weights]) Compute the histogram of a dataset.
 - histogram2d(x, y[, bins, range, density, ...]) Compute the bi-dimensional histogram of two data samples.
 - histogramdd(sample[, bins, range, density, ...]) Compute the multidimensional histogram of some data.
 - bincount(x, /[, weights, minlength]) Count number of occurrences of each value in array of non-negative ints.
 - histogram_bin_edges(a[, bins, range, weights]) Function to calculate only the edges of the bins used by the histogram function.
 - digitize(x, bins[, right]) Return the indices of the bins to which each value in input array belongs.

Averages and variances

  - median(a[, axis, out, overwrite_input, keepdims]) Compute the median along the specified axis.
  - average(a[, axis, weight  s, returned, keepdims]) Compute the weighted average along the specified axis.
  - mean(a[, axis, dtype, out, keepdims, where]) Compute the arithmetic mean along the specified axis.
  - std(a[, axis, dtype, out, ddof, keepdims, where]) Compute the standard deviation along the specified axis.
  - var(a[, axis, dtype, out, ddof, keepdims, where]) Compute the variance along the specified axis.
  - nanmedian(a[, axis, out, overwrite_input, ...]) Compute the median along the specified axis, while ignoring NaNs.
  - nanmean(a[, axis, dtype, out, keepdims, where]) Compute the arithmetic mean along the specified axis, ignoring NaNs.
  - nanstd(a[, axis, dtype, out, ddof, ...]) Compute the standard deviation along the specified axis, while ignoring NaNs.
  - nanvar(a[, axis, dtype, out, ddof, ...]) Compute the variance along the specified axis, while ignoring NaNs.
 */
exports.kw_exported = {
    quantile: kwargs_1.Func_a_q_axis.defaultDecorator(quantile),
    nanquantile: kwargs_1.Func_a_q_axis.defaultDecorator(nanquantile),
    percentile: kwargs_1.Func_a_q_axis.defaultDecorator(percentile),
    nanpercentile: kwargs_1.Func_a_q_axis.defaultDecorator(nanpercentile),
    median: kwargs_1.Func_a_axis_keepdims.defaultDecorator(median),
    nanmedian: kwargs_1.Func_a_axis_keepdims.defaultDecorator(nanmedian),
};
